<template>
   <!--  <template v-if="!signedIn">
        <router-view @signedIn="setSignedIn"/>
    </template> -->
    <!-- <template v-if="signedIn"> -->
        <div :class="containerClass" :data-theme="colorScheme" @click="onDocumentClick($event)">
            <div class="layout-content-wrapper">
                <AppTopBar :topbarNotificationMenuActive="topbarNotificationMenuActive" :topbarUserMenuActive="topbarUserMenuActive"
                        :layoutMode="layoutMode" :menu="menu" :menuActive="menuActive" :staticMenuMobileActive='staticMenuMobileActive'
                        @menu-click="onMenuClick" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick"
                        @menu-button-click="onMenuButtonClick" @search-click="toggleSearch" @topbar-notification="onTopbarNotificationMenuButtonClick"
                        @topbar-user-menu="onTopbarUserMenuButtonClick" @right-menu-click="onRightMenuButtonClick" @right-menubutton-click="onRightMenuButtonClick"></AppTopBar>
                 <AppMenu :model="menu" :layoutMode="layoutMode" :active="menuActive" :mobileMenuActive="staticMenuMobileActive"
                 @menu-click="onMenuClick" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick"
                 :token="this.token"></AppMenu>


                <div class="layout-content">
                    <div class="layout-breadcrumb viewname" style="text-transform: uppercase">
                        <template v-if="$route.meta.breadcrumb">
                            <span>{{$route.meta.breadcrumb[0].label}}</span>
                        </template>
                    </div>
                    <router-view @signedIn="setSignedIn"/>
                </div>
                <AppFooter/>
            </div>
        </div>
    <!-- </template> -->

    <!-- Para cuando hay una versión nueva -->
    <Dialog header="Nueva versión" v-model:visible="prompt" :modal="true" :breakpoints="{'960px': '75vw'}" :style="{width: '30vw'}" :closable="false" :closeOnEscape="false">
        <p>
        Se encontró una nueva versión del sistema. Para evitar mal funcionamiento <b>se recomienda actualizar</b> para cargarlo.
        </p>
        <template #footer>
            <Button label="Actualizar" icon="pi pi-check" @click="update" class="p-button-text" autofocus />
        </template>
    </Dialog>

</template>

<script>
import EventBus from './event-bus';
import AppTopBar from "./AppTopbar";
import AppFooter from "./AppFooter";
import AppMenu from "./AppMenu";
/* import SmartService from './service/SmartService'; */
export default {
    data() {
        return {
            signedIn: false,
            menuActive: false,
            layoutMode: "slim",
            colorScheme: "light",
            menuTheme: "layout-sidebar-indigo",
            overlayMenuActive: false,
            staticMenuDesktopInactive: false,
            staticMenuMobileActive: false,
            menuClick: false,
            searchActive: false,
            searchClick: false,
            userMenuClick: false,
            topbarUserMenuActive: false,
            notificationMenuClick: false,
            topbarNotificationMenuActive: false,
            rightMenuClick: false,
            rightMenuActive: false,
            configActive: false,
            configClick: false,
            prompt: false,
            menu: [
                {
                label: "Datos de Sesión", icon: "pi pi-map",
                    items: [
                        {label: "Comedor", icon: "pi pi-map-marker", to: "/puntomovil"},
                        {label: "Multiplicador", icon: "pi pi-bolt", to: "/multiplicador"},
                    ],
                },
                { separator: true },
                {
                    label: "Entregar", icon: "pi pi-box",
                    items: [
                        {label: "Lectura QR", icon: "pi pi-qrcode", to: "/entregaqr"},
                        {label: "Excepcional", icon: "pi pi-exclamation-circle", to: "/entregaexcepcion"},
                    ],
                },
                { separator: true },
                {
                    label: "Remitos", icon: "pi pi-file",
                    items: [
                        {label: "Entrada / salida", icon: "pi pi-arrow-right-arrow-left", to: "/remitos"},
                    ],
                },
                { separator: true },
                {
                    label: "Reportes", icon: "pi pi-chart-pie",
                    items: [
                        {label: "Reporte diario", icon: "pi pi-chart-bar", to: "/reportediario"},
                        {label: "Remitos del día", icon: "pi pi-file", to: "/reporteremitos"},
                    ],
                },
            ],
        };
    },
    mounted() {
        /* if(!this.signedIn) {
            this.$router.replace({ name: "login" });
        } */
        if (!localStorage.token && window.location.href.indexOf("iduy-login") == -1) {
			this.$router.replace({ name: "login" });
        }
    },
    created() {
        if (this.$workbox) {
            this.$workbox.addEventListener("waiting", () => {
                this.prompt = true;
            });
        }
    },
    computed: {
        containerClass() {
            return [
                "layout-wrapper",
                {
                    "layout-overlay": this.layoutMode === "overlay",
                    "layout-static": this.layoutMode === "static",
                    "layout-slim": this.layoutMode === "slim",
                    'layout-horizontal': this.layoutMode === 'horizontal',
                    "layout-sidebar-dim": this.colorScheme === "dim",
                    "layout-sidebar-dark": this.colorScheme === "dark",
                    "layout-overlay-active": this.overlayMenuActive,
                    "layout-mobile-active": this.staticMenuMobileActive,
                    "layout-static-inactive": this.staticMenuDesktopInactive && this.layoutMode === "static",
                    "p-input-filled": this.$primevue.config.inputStyle === "filled",
                    "p-ripple-disabled": !this.$primevue.config.ripple,
                },
                this.colorScheme === "light" ? this.menuTheme : "",
            ];
        },
    },
    components: {
        AppTopBar,
        AppFooter,
        AppMenu,
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        },
    },
    methods: {
        async update() {
            this.prompt = false;
            await this.$workbox.messageSW({ type: "SKIP_WAITING" });
        },
        setSignedIn(status) {
            this.signedIn = status;
        },
        
        logout() {
            let url = localStorage.urlIDUruguay+"/logout?id_token_hint="+localStorage.tokenExt+"&post_logout_redirect_uri="+encodeURIComponent(localStorage.urlLogout);
            this.signedIn = false;
			localStorage.clear();		
            //this.$router.replace({ name: "login" });
            console.log(url);
			window.location = url;
        },
        onDocumentClick() {
            if (!this.searchClick && this.searchActive) {
                this.onSearchHide();
            }

            if (!this.userMenuClick) {
                this.topbarUserMenuActive = false;
            }

            if (!this.notificationMenuClick) {
                this.topbarNotificationMenuActive = false;
            }

            if (!this.rightMenuClick) {
                this.rightMenuActive = false;
            }

            if (!this.menuClick) {
                if (this.isSlim() || this.isHorizontal()) {
					EventBus.emit('reset-active-index');
					this.menuActive = false;
                }

                if (this.overlayMenuActive || this.staticMenuMobileActive) {
                    this.hideOverlayMenu();
                }

                this.unblockBodyScroll();
            }

            if (this.configActive && !this.configClick) {
                this.configActive = false;
            }

            this.searchClick = false;
            this.configClick = false;
            this.userMenuClick = false;
            this.rightMenuClick = false;
            this.notificationMenuClick = false;
            this.menuClick = false;
        },
        onMenuClick() {
            this.menuClick = true;
        },
        onMenuButtonClick(event) {
            this.menuClick = true;
            this.topbarUserMenuActive = false;
            this.topbarNotificationMenuActive = false;
            this.rightMenuActive = false;

            if (this.isOverlay()) {
                this.overlayMenuActive = !this.overlayMenuActive;
            }

            if (this.isDesktop()) {
                this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
            } else {
                this.staticMenuMobileActive = !this.staticMenuMobileActive;
                if (this.staticMenuMobileActive) {
                    this.blockBodyScroll();
                } else {
                    this.unblockBodyScroll();
                }
            }

            event.preventDefault();
        },
        onMenuItemClick(event) {
			if (!event.item.items) {
				EventBus.emit('reset-active-index');
				this.hideOverlayMenu();
			}
			if (!event.item.items && (this.isSlim() || this.isHorizontal())) {
                this.menuActive = false;
            }
        },
		onRootMenuItemClick() {
            this.menuActive = !this.menuActive;
        },
        onTopbarUserMenuButtonClick(event) {
            this.userMenuClick = true;
            this.topbarUserMenuActive = !this.topbarUserMenuActive;

            this.hideOverlayMenu();

            event.preventDefault();
        },
        onTopbarNotificationMenuButtonClick(event) {
            this.notificationMenuClick = true;
            this.topbarNotificationMenuActive = !this.topbarNotificationMenuActive;

            this.hideOverlayMenu();

            event.preventDefault();
        },
        toggleSearch() {
            this.searchActive = !this.searchActive;
            this.searchClick = true;
        },
        onSearchClick() {
            this.searchClick = true;
        },
        onSearchHide() {
            this.searchActive = false;
            this.searchClick = false;
        },
        onRightMenuClick() {
			this.rightMenuClick = true;
		},
        onRightMenuButtonClick(event) {
			this.rightMenuClick = true;
			this.rightMenuActive = !this.rightMenuActive;
			this.hideOverlayMenu();
			event.preventDefault();
		},
        onConfigClick() {
            this.configClick = true;
        },
        onConfigButtonClick() {
            this.configActive = !this.configActive;
            this.configClick = true;
        },
        hideOverlayMenu() {
            this.overlayMenuActive = false;
            this.staticMenuMobileActive = false;
            this.unblockBodyScroll();
        },
        blockBodyScroll() {
            if (document.body.classList) {
                document.body.classList.add('blocked-scroll');
            } else {
                document.body.className += ' blocked-scroll';
            }
        },
        unblockBodyScroll() {
            if (document.body.classList) {
                document.body.classList.remove('blocked-scroll');
            } else {
                document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                    'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
            }
        },
        isSlim() {
            return this.layoutMode === "slim";
        },
        isHorizontal() {
            return this.layoutMode === "horizontal";
        },
        isOverlay() {
            return this.layoutMode === "overlay";
        },
        isDesktop() {
            return window.innerWidth > 1091;
        }
    },
};
</script>

<style lang="scss">
@import "App.scss";
</style>
